module.exports = __webpack_public_path__ + "img/soprano.80b19e10.jpg";